import * as types from "../constants/actionConstants";
import TagApi from "../api/TagApi";


export function initializeTagEditorCreate(template = {}) {
    return {
        type: types.TAG_EDITOR_INITIALIZE,
        payload: {
            template: {
                id: "",
                name: (template.name)? template.name : "",
                trackable: false
            },
            questionKeys: [],
            options: {
                createMode: true,
                validate: [],
                isValidating: false
            }
        }
    };
}

export function initializeTagEditorEdit(template) {
    return {
        type: types.TAG_EDITOR_INITIALIZE,
        payload: {
            template: template,
            questionKeys: template.questionKeys || [],
            options: {
                hasScript: !!template.script,
                hasDescription: !!template.description,
                createMode: false,
                validate: [],
                isValidating: false
            }
        }
    };
}

export function updateTagTemplate(template, options) {
    return {
        type: types.TAG_EDITOR_UPDATE,
        payload:{
            template,
            options
        }
    };
}

export function clearTagEditor() {
    return {
        type: types.TAG_EDITOR_CLEAR
    };
}


export function validateTagNameUnique(name) {
    return (dispatch) => {
        dispatch({type: types.TAG_EDITOR_NAME_VALIDATING});
        dispatch(checkTagNameExists(name))
    };
}

export function checkTagNameExists(name) {
    let thunk = (dispatch) => {
        TagApi.checkTagNameExists(name).then((data) => {
            dispatch({type: types.TAG_EDITOR_NAME_EXISTS, list: data.collection});
        });
    };

    thunk.meta = {
        debounce: {
            time: 1000,
            key: "__tagExistsCheck",
            leading: false,
            trailing: true
        }
    };

    return thunk;
}

// ---------------------------------------------------------------------------------------------------------------------
// Tags can be associated with questions, but no reorder is required
// ---------------------------------------------------------------------------------------------------------------------

export function addTagQuestion(question) {
    return {
        type: types.TAG_EDITOR_ADD_QUESTION,
        question
    };
}

export function removeTagQuestion(index) {
    return {type: types.TAG_EDITOR_REMOVE_QUESTION, index: index};
}


